<template>
  <el-tag :size="size" closable @close.stop="deleteVideo" class="custom-tag"
    :style="{ backgroundColor: customBgColor, color: customTextColor }">
    <el-link style="font-size: 18px;" type="primary" @click="videoPreview">{{ text }} <i v-if="icon" :class="'el-icon-' + icon"></i></el-link>
    <PreviewVideo :isTcVideo="isTcVideo" v-if="showPreviewVideo" @close="close"  :type="1"  ref="previewVideo" />

  </el-tag>
</template>

<script>
import PreviewVideo from '/src/views/manage-class/components/PreviewVideo.vue';
export default {
  name: 'CustomTag',
  components: {
    PreviewVideo
  },
  props: {
    size: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    // 原始 el-tag 的 type
    type: {
      type: String,
      default: '', // 可选值: success/info/warning/danger ''
      validator: value => ['success', 'info', 'warning', 'danger', ''].includes(value)
    },
    // 自定义背景色
    bgColor: {
      type: String,
      default: null
    },
    // 自定义文字颜色
    textColor: {
      type: String,
      default: null
    },
    VideoInfo: {
      type: Object,
      default: null
    },
    QuestionID: {
      type: String,
      default: null
    },

  },
  data(){
    return{
      isTcVideo:false,
      showPreviewVideo:false
    }
  },
  computed: {
    // 如果设置了 bgColor，则使用该颜色作为背景色，否则为空
    customBgColor() {
      return this.bgColor ? this.bgColor : null;
    },
    // 如果设置了 textColor，则使用该颜色作为文字颜色，否则为空
    customTextColor() {
      return this.textColor ? this.textColor : null;
    }
  },
  methods: {
    close(){
      this.showPreviewVideo =false
    },
    async deleteVideo() {

      this.$confirm('确认解除关联？', {
        showClose: false,
        type: 'warning',

      })
        .then(async _ => {
          try {
            await this.$api.DelReferedQuestion({
              QuestionID: this.QuestionID,
              VideoID: this.VideoInfo.VideoID,
            });
            this.$message.success('解除关联成功');
            this.$emit('UpdateList')
          } catch (error) {
            this.$message.error(error?.message);
          }
        })
        .catch(_ => { });

    },
    videoPreview() {
      console.log(this.VideoInfo)
      this.showPreviewVideo =true
      this.isTcVideo=this.VideoInfo.VideoSource=='TcVOD'
      this.$nextTick(()=>{
      this.$refs.previewVideo.show(this.VideoInfo);
      })

    },
  }
};
</script>

<style scoped>
.custom-tag {
  box-sizing: content-box;
  padding: 4px 8px 4px;
  margin-right: 12px;
}

.custom-tag i:last-child {
  margin-left: 5px;
  margin-right: 0;
}
</style>